<div class="container-fluid-page">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="backPage()"
    />&nbsp; <span class="pageTitle">Dominant Market</span>
  </div>
  <div class="profile_details">
    <div class="button" style="float: right">
      <!-- <button class="close" mat-button (click)="onClear()">X</button> -->
    </div>

    <div class="page__content shadow p-3">
      <form
        class="d-flex justify-content-between align-item-center"
        [formGroup]="dominateForm"
        (ngSubmit)="dominateFilterForm()"
      >
        <mat-form-field>
          <mat-select formControlName="marketName" placeholder="Market Name">
            <mat-option *ngFor="let opt of marketList" [value]="opt.marketName">
              {{ opt.marketName }}
            </mat-option>
          </mat-select> </mat-form-field
        >&nbsp;&nbsp;
        <mat-form-field>
          <mat-select
            placeholder="Crop"
            formControlName="cropName"
            placeholder="Crop Type"
          >
            <mat-option *ngFor="let opt of cropList" [value]="opt.cropName">
              {{ opt.cropName }}
            </mat-option>
          </mat-select> </mat-form-field
        >&nbsp;&nbsp;

        <mat-form-field>
          <mat-select formControlName="productType" placeholder="Product Type">
            <mat-option
              *ngFor="let opt of productList"
              [value]="opt.productType"
            >
              {{ opt.productType }}
            </mat-option>
          </mat-select> </mat-form-field
        >&nbsp;&nbsp;

        <mat-form-field>
          <mat-select
            formControlName="subProductType"
            placeholder="Sub Product type"
          >
            <mat-option
              *ngFor="let opt of subProductList"
              [value]="opt.subProductTypeName"
            >
              {{ opt.subProductTypeName }}
            </mat-option>
          </mat-select> </mat-form-field
        >&nbsp;&nbsp;

        <section class="example-section">
          <mat-checkbox
            color="primary"
            class="example-margin"
            formControlName="isdominant"
            >Dominant</mat-checkbox
          >
        </section>

        <div class="btnSpace">
          <button
            type="submit"
            style="margin-top: 12px; margin-right: 10px; height: 5vh"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>

          <button
            type="button"
            class="btn btn-primary mat-primary clear_button pull-right"
            style="margin-top: 12px; height: 5vh"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
        </div>
      </form>

      <div
        class="text_filter_data"
        *ngIf="this.dominateDataList?.list.length == 0"
      >
        <p>
          There's no record found with the given criteria, please try again
          refining your search and filters
        </p>
      </div>

      <!-- table  -->
      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="marketName">
            <mat-header-cell *matHeaderCellDef> Market Name </mat-header-cell>
            <mat-cell *matCellDef="let dominateDataList">{{
              dominateDataList.marketName
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="crop">
            <mat-header-cell *matHeaderCellDef> Crop </mat-header-cell>
            <mat-cell *matCellDef="let dominateDataList">{{
              dominateDataList.cropName
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="productType">
            <mat-header-cell *matHeaderCellDef> Product Type </mat-header-cell>
            <mat-cell *matCellDef="let dominateDataList">
              <span class="categoryList">{{
                dominateDataList.productTypeName
              }}</span>
            </mat-cell>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="subProductType">
            <mat-header-cell *matHeaderCellDef>
              Sub Product Type
            </mat-header-cell>
            <mat-cell *matCellDef="let dominateDataList">
              <span class="categoryList">{{
                dominateDataList.subproductType
              }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dominateMarket">
            <mat-header-cell *matHeaderCellDef>
              Dominant Market
            </mat-header-cell>
            <mat-cell *matCellDef="let dominateDataList">
              <section class="example-section">
                <mat-checkbox
                  color="primary"
                  class="example-margin"
                  [checked]="dominateDataList.isdominant"
                  (change)="checkDominant(dominateDataList, $event)"
                ></mat-checkbox>
              </section>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <!-- <mat-row style="cursor: pointer;" *matRowDef="let userlist; columns: displayedColumns;"></mat-row> -->
        </mat-table>
        <mat-paginator
          [length]="length"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 20, 50, 100]"
          (page)="getServerData($event)"
          showFirstLastButtons
          aria-label=""
        >
        </mat-paginator>
      </div>
    </div>
  </div>

  <style>
    .page__content {
      /* min-height: calc(56vh - 80px) !important; */
      border-radius: 10px;
      margin-top: 1rem;
      background: white;
      color: black;
      font-size: 2rem;
    }

    .container-fluid {
      height: 60%;
      /* margin-top: -1rem; */
    }

    .name {
      height: 10px;
    }
  </style>
</div>
